import React from "react";
import { useTranslation } from "react-i18next";
const GreyNoiseAdapterSummary = () => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("grey_noise_adapter_summary.api_token_label")), /* @__PURE__ */ React.createElement("dd", null, "******"));
};
export default GreyNoiseAdapterSummary;
